/* eslint-disable @typescript-eslint/no-explicit-any -- aligné U3106 */
import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import U2000ActionBtn from "../../../u2000Core/components/buttons/U2000ActionBtn";
import U2000ResponsiveToolbar from "../../../u2000Core/components/toolbar/U2000ResponsiveToolbar";
import { FaChartBar, FaPlay } from "react-icons/fa";
import { useU2000AuthContext } from "../../../u2000Core/context/auth/U2000UseAuthContext";
import type { U2000TableHandlers } from "../../../u2000Core/types/U2000TableHandlers";
import { NS, U3134ROLES } from "../../U3134";

interface U3134WorkInProgressListToolBarProps<T extends Record<string, any>> {
  handlerActions?: U2000TableHandlers<T>;
  isGeneratingWip?: boolean;
}

export const U3134WorkInProgressListToolBar: React.FC<U3134WorkInProgressListToolBarProps<Record<string, any>>> = ({
  handlerActions,
  isGeneratingWip = false,
}) => {
  const { t } = useTranslation();
  const { hasRole } = useU2000AuthContext();
  const navigate = useNavigate();

  const actions = [
    {
      key: "generateWip",
      label: t("btnGenerateWip", { ns: NS }),
      hasRole: hasRole(U3134ROLES.GENERATE),
      handleClick: handlerActions?.onSpecialAction,
      icon: FaPlay,
      disabled: isGeneratingWip,
      Component: U2000ActionBtn,
    },
    {
      key: "tecAgeReport",
      label: t("btnTecAgeReport", { ns: NS }),
      hasRole: hasRole(U3134ROLES.READ),
      handleClick: () => navigate("/U3134/reports/tec-age"),
      icon: FaChartBar,
      Component: U2000ActionBtn,
    },
  ];

  return <U2000ResponsiveToolbar actions={actions} />;
};
